import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("eh_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const get = (url, params) => api.get(url, { params }).then((r) => r.data);
export const img = (key) => `/images/${key || "p9716228"}.jpg`;
export const money = (n) => (n == null ? "Not reported" : `$${Math.round(n).toLocaleString()}`);
export const communityUrl = (c) => `/${c.state_slug}/${c.city_slug}/${c.slug}`;
export const hoaName = (n = "") => (/\b(hoa|poa|coa|association|association,? inc\.?|inc\.?)\s*$/i.test(n.trim()) ? n.trim() : `${n.trim()} HOA`);
export const feeOrNA = (v, suffix = "") => (v == null ? "Not reported" : `$${Math.round(v).toLocaleString()}${suffix}`);
export const siteUrl = () => window.location.origin;

export const BRAND = "Explore HOA's";
export const COMPANY = "Digital Properties, LLC";
export const CONTACT_EMAIL = "hello.digitalproperties@gmail.com";

export const STATUS = {
  verified: { label: "Verified HOA", cls: "bg-[#E6F4F1] text-[#027A6D] border-[#63D8C4]", hint: "Details confirmed with the association." },
  researched: { label: "Researched Listing", cls: "bg-[#EEF7E6] text-[#3F6B1F] border-[#B0E090]", hint: "Fees and details compiled from public real estate sources (source shown on the page). Confirm with the HOA." },
  listing: { label: "Directory Listing", cls: "bg-[#F1F5F9] text-[#0B2150] border-[#CBD5E1]", hint: "Name, address, phone and website come from public business listings. Fees and rules have not been reported yet." },
  pending: { label: "Pending Verification", cls: "bg-[#EFF6FF] text-[#1E40AF] border-[#93C5FD]", hint: "Submitted by the community and awaiting verification." },
  hidden: { label: "Hidden", cls: "bg-slate-100 text-slate-600 border-slate-300", hint: "Not shown publicly." },
};

export const RENTAL_OPTIONS = [
  { value: "none", label: "No restrictions" },
  { value: "allows_rentals", label: "Rentals allowed (any terms)" },
  { value: "short_term_banned", label: "No short-term rentals" },
  { value: "prohibited", label: "Rentals prohibited" },
];
export const RENTAL_LABEL = { ...Object.fromEntries(RENTAL_OPTIONS.map((o) => [o.value, o.label])), min_lease: "Minimum lease term", cap: "Rental cap" };
export const AMENITY_OPTIONS = ["Pool", "Clubhouse", "Tennis Courts", "Pickleball", "Fitness Center", "Playground",
  "Walking Trails", "Dog Park", "Gated Entry", "Lake / Pond", "Golf Course"];
export const TYPE_OPTIONS = ["Single-Family", "Townhome", "Condominium", "Mixed Residential", "55+ Active Adult"];
export const US_STATES = ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware",
  "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky",
  "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana",
  "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
  "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah",
  "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"];

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
